import React from 'react'
import { Link, graphql, useStaticQuery } from 'gatsby'
import { useMediaQuery } from 'react-responsive'

import hyphenate from '../utils/hyphenate'

import Modal from './Modal/Modal'

import {
  Container,
  Content,
  SearchArticles,
  SearchArticle,
  SearchArticleData,
  SearchArticleImage,
  SearchArticleNonImage,
  ButtonsDiv,
} from '../styles/searchModal.styles'
import ContainedButton from './ContainedButton'

export default function SearchModal(props) {
  const data = useStaticQuery(graphql`
    query SearchModalQuery {
      allContentfulBlogPost(sort: { order: DESC, fields: createdAt }) {
        edges {
          node {
            thumbnail {
              fixed(width: 286, height: 150, toFormat: JPG) {
                src
              }
              title
            }
            compress: thumbnail {
              fixed(width: 286, height: 150, toFormat: WEBP) {
                src
              }
              title
            }
            lqip: thumbnail {
              fixed(width: 286, height: 150, toFormat: JPG, quality: 10) {
                src
              }
              title
            }
            category
            title
            createdAt(formatString: "D MMM YYYY")
            updatedAt(formatString: "D MMM YYYY")
            slug
          }
        }
        totalCount
      }
    }
  `)

  const isTabletOrMobile = useMediaQuery({
    query: '(max-width: 1024px)',
  })

  const [articleSearch, setArticleSearch] = React.useState('')
  const [trigger, setTrigger] = React.useState(0)

  const [page, setPage] = React.useState(1)
  const articlesPerPage = 4
  const start = articlesPerPage * page - articlesPerPage
  const end = articlesPerPage * page
  let articleCount = data.allContentfulBlogPost.totalCount
  const pageCount = () => {
    if (articleCount % articlesPerPage === 0) {
      return articleCount / articlesPerPage
    } else {
      return Math.floor(articleCount / articlesPerPage) + 1
    }
  }

  const filterCount = (array) => {
    let array2 = array.filter((edge) =>
      edge.node.title.toLowerCase().includes(articleSearch.toLowerCase())
    )
    articleCount = array2.length
    return array2
  }

  React.useEffect(() => {
    !isTabletOrMobile && document.getElementById('search').focus()
    if (isTabletOrMobile && trigger !== 0) {
      document.getElementById('top').scrollIntoView()
    }
  }, [trigger])

  const removeFocus = (e) => {
    if (e.key === 'Enter') {
      e.target.blur()
    }
  }

  return (
    <>
      <Modal id="portal" exitCallback={props.exitCallback}>
        <Container id="top">
          <Content>
            <input
              type="search"
              placeholder="Search"
              id="search"
              spellCheck={false}
              autoComplete="off"
              onChange={(e) => {
                setArticleSearch(e.target.value)
                setPage(1)
              }}
              onKeyDown={removeFocus}
            />
            <SearchArticles>
              {filterCount(data.allContentfulBlogPost.edges)
                .slice(start, end)
                .map((edge, index) => (
                  <SearchArticle key={index}>
                    <Link
                      to={`/${hyphenate(
                        edge.node.category
                      )}/${edge.node.slug.toLowerCase()}/`}
                      onClick={props.exitCallback}
                    >
                      <SearchArticleData>
                        <SearchArticleImage>
                          <picture>
                            <source
                              srcSet={edge.node.compress.fixed.src}
                              type="image/webp"
                            />
                            <img
                              alt={edge.node.thumbnail.title || 'image'}
                              src={edge.node.thumbnail.fixed.src}
                            />
                          </picture>
                        </SearchArticleImage>
                        <SearchArticleNonImage>
                          <h3>{edge.node.title}</h3>
                          <div>
                            <span>{edge.node.category}</span>
                            <span>{edge.node.updatedAt}</span>
                          </div>
                        </SearchArticleNonImage>
                      </SearchArticleData>
                    </Link>
                  </SearchArticle>
                ))}
            </SearchArticles>
            <ButtonsDiv>
              <ContainedButton
                disabled={page <= 1}
                onClick={() => {
                  setPage(page - 1)
                  setTrigger(trigger + 1)
                }}
              >
                Back
              </ContainedButton>
              <ContainedButton
                disabled={page >= pageCount()}
                onClick={() => {
                  setPage(page + 1)
                  setTrigger(trigger + 1)
                }}
              >
                Next
              </ContainedButton>
            </ButtonsDiv>
          </Content>
        </Container>
      </Modal>
    </>
  )
}
